module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="panel-container">\n\n  <div class="search">\n    <input id="search-button" placeholder="Search" type="text" />\n    <span id="search-icon"><%- searchIcon %></span>\n  </div>\n  <div id="cam-context-switcher-tab-container" class="context-switcher-tab-buttons">\n    <a id="cam-context-switcher-favorite-tab" class="context-switcher-tab-button"><span>Favorites</span></a>\n    <a id="cam-context-switcher-organization-tab" class="context-switcher-tab-button"><span>Organizations</span></a>\n    <a id="cam-context-switcher-costcenter-tab" class="context-switcher-tab-button"><span>Cost Centers</span></a>\n    <a id="cam-context-switcher-workspace-tab" class="context-switcher-tab-button"><span>Workspaces</span></a>\n  </div>\n  <div id="cam-context-switcher-tabs" class="lists">\n  </div>\n</div>\n',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="panel-container">\n\n  <div class="search">\n    <input id="search-button" placeholder="Search" type="text" />\n    <span id="search-icon">', (__stack.lineno = 5, searchIcon), '</span>\n  </div>\n  <div id="cam-context-switcher-tab-container" class="context-switcher-tab-buttons">\n    <a id="cam-context-switcher-favorite-tab" class="context-switcher-tab-button"><span>Favorites</span></a>\n    <a id="cam-context-switcher-organization-tab" class="context-switcher-tab-button"><span>Organizations</span></a>\n    <a id="cam-context-switcher-costcenter-tab" class="context-switcher-tab-button"><span>Cost Centers</span></a>\n    <a id="cam-context-switcher-workspace-tab" class="context-switcher-tab-button"><span>Workspaces</span></a>\n  </div>\n  <div id="cam-context-switcher-tabs" class="lists">\n  </div>\n</div>\n');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/cam-context-switcher/templates/cam-context-switcher-panel.ejs
// module id = 279
// module chunks = 0 1